<div class="container-fluid">
  <div class="row justify-content-center mt-5">
    <header class="header">
      <h3 class="text-center">Client Form</h3>
    </header>
    <div class="col-7">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="addClientForm" (ngSubmit)="addClient()">

            <div class="mb-3">
              <label for="clientName" class="form-label">Client Name</label>
              <input 
                type="text" 
                formControlName="clientName" 
                id="clientName" 
                class="form-control" 
                placeholder="Client Name" 
              />
              <div *ngIf="addClientForm.get('clientName')?.invalid && (addClientForm.get('clientName')?.dirty || addClientForm.get('clientName')?.touched)" class="text-danger">
                <div *ngIf="addClientForm.get('clientName')?.errors?.required">Client Name is required.</div>
                <div *ngIf="addClientForm.get('clientName')?.errors?.minlength">Must be at least 3 characters long.</div>
              </div>
            </div>

            <div class="mb-3">
              <label for="contactNo" class="form-label">Contact No</label>
              <input 
                type="text" 
                formControlName="contactNo" 
                id="contactNo" 
                class="form-control" 
                placeholder="Phone Number" 
              />
              <div *ngIf="addClientForm.get('contactNo')?.invalid && (addClientForm.get('contactNo')?.dirty || addClientForm.get('contactNo')?.touched)" class="text-danger">
                <div *ngIf="addClientForm.get('contactNo')?.errors?.required">Contact Number is required.</div>
                <div *ngIf="addClientForm.get('contactNo')?.errors?.pattern">Must be numeric.</div>
                <div *ngIf="addClientForm.get('contactNo')?.errors?.minlength">Must be at least 10 digits long.</div>
                <div *ngIf="addClientForm.get('contactNo')?.errors?.maxlength">Must be no longer than 15 digits.</div>
              </div>
            </div>

            <div class="mb-3">
              <label for="email" class="form-label">Email Id</label>
              <input 
                type="email" 
                formControlName="email" 
                id="email" 
                class="form-control" 
                placeholder="Email" 
              />
              <div *ngIf="addClientForm.get('email')?.invalid && (addClientForm.get('email')?.dirty || addClientForm.get('email')?.touched)" class="text-danger">
                <div *ngIf="addClientForm.get('email')?.errors?.required">Email is required.</div>
                <div *ngIf="addClientForm.get('email')?.errors?.email">Invalid email address.</div>
              </div>
            </div>

            <div class="text-end">
              <button 
                type="submit" 
                class="btn btn-outline-dark" 
                [disabled]="addClientForm.invalid"
              >
                {{ isUpdateMode ? 'Update' : 'Submit' }}
              </button>
            </div>
          </form>
        </div> <!-- end card-body -->
      </div><!-- end card -->
    </div><!-- end col -->
  </div><!-- end row -->
</div><!-- end container -->


  